import {useQueryClient} from '@tanstack/react-query'
import TerminItem from 'Components/Agreement/TerminItem'
import BreadCrumb from 'Components/Common/BreadCrumb'
import DeleteModal from 'Components/Common/DeleteModal'
import withTable from 'Components/Common/Table/withTable'
import {DATA_LIMIT} from 'configs'
import {TermintRQ} from 'Hooks/Queries'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Container, Row} from 'reactstrap'

export default function ListTermint() {
  const [deleteAgreementId, setDeleteAgreementId] = useState(null)
  const [deleteModal, setDeleteModal] = useState(false)
  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(DATA_LIMIT)
  const [keyword, setKeyword] = useState(null)
  const {status, data, error, isFetching, refetch} = TermintRQ.useGetDataList()(
    false,
    keyword,
    offset,
    limit,
  )

  const onPageChange = (i) => {
    setOffset(i.selected)
  }

  const onPerPageChange = (i) => {
    setLimit(i)
    setOffset(0)
  }

  const onKeywordChange = (value) => {
    setKeyword(value)
  }

  const useQuery = useQueryClient()
  const navigate = useNavigate()

  const onDeleteSuccess = (key) => {
    setDeleteModal(false)
    setDeleteAgreementId(null)
    useQuery.invalidateQueries({queryKey: [key]})
    refetch()
  }

  const {mutate: deleteTruck} = TermintRQ.useDeleteData(onDeleteSuccess)()

  const onDeleteConfirm = () => {
    deleteTruck(deleteAgreementId)
  }

  const onAddButtonClicked = () => {
    navigate('/app/termint/create')
  }
  const onDeleteClick=(id)=> {
    setDeleteAgreementId(id)
    setDeleteModal(true)
  }

  const TermintTable = withTable(
    TerminItem,
    'termint',
    ['NO', 'aksi', 'termin', 'persentase'],
    onDeleteClick,
    onAddButtonClicked,
  )

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title='Termint' />
        <Row>
          <TermintTable
            data={data}
            isFetching={isFetching}
            loading={isFetching}
            error={error}
            status={status}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            onKeywordChange={onKeywordChange}
            keyword={keyword}
          />
        </Row>
        <DeleteModal
          onDeleteConfirm={() => onDeleteConfirm()}
          onCloseClick={() => setDeleteModal((v) => !v)}
          show={deleteModal}
          loading={false}
        />
      </Container>
    </div>
  )
}
